import { DwModuleType, DwVersionInfo } from "@devwareapps/devware-cap";

export const angularApplicationVersion: DwVersionInfo = {
    ModuleName: 'Pilexos-Angular',
    ModuleType: DwModuleType.application,
    ProductVersion: '2.1.15',
    PublishDateTime: '06/10/2025 02:55:52 PM'
}
